













































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3,logoutPanel,printLabelPanel } from "@/components";
import { TbGoods } from '@/http';
import { fmoney } from '@/common/util/money';
import { Toast } from 'vant';
const { userAgent } = navigator;
const isAndroid = userAgent.indexOf('Android') > -1 ||userAgent.indexOf('android') > -1 || userAgent.indexOf('Adr') > -1;; // android终端
@Component({
    components: {
        padHeadPanel3,logoutPanel,printLabelPanel
    },
})
export default class viewProduct extends Vue {
    public $refs: {
    };
    id="";
    form:any={
        costPrice:0,
        sellingPrice:0,
        goodDiscount:null,
        discountPrice:0,
        memberPriceRange:''
    };

    /**其他店铺库存 */
    show=false;

    otherList=[];

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=2;

    userInfo:any={};

    fmoney= fmoney;

    printShow = false;

    created() {
        this.id = this.$route.query.id;
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"))
    }
    mounted(){
        this.init();
       
    }

    
    get otherTotalSaleNum(){
        let val = 0;
        if(this.otherList.length>0){
            let arr= this.otherList.map(v=>Number(this.getSaleNumTotal(v.goods)));
            val = arr.reduce((a,b)=>(Number(a)+Number(b)).toFixed(0))
        }
        return val;
    }
    get otherTotalStock(){
        let val = 0;
        if(this.otherList.length>0){
            let arr= this.otherList.map(v=>Number(this.getStockTotal(v.goods)));
            val = arr.reduce((a,b)=>(Number(a)+Number(b)).toFixed(0))
        }
        return val;
    }
    async init(){
        let res = await TbGoods.GetTbGoodsById({
            id:this.id
        });
        this.form = res;
    }
    closeFun(){
        this.show = false;
    }
    async viewOther(){
        await this.getOther();
        this.show = true;
    }
    async getOther(){
        let res = await TbGoods.GetGoodsListByArticleNo({
            articleNo:this.form.articleNo,
            shopid:this.userInfo.shopId
        });
        this.otherList = res.items;
    }
    getSaleNumTotal(arr){
        let val = 0;
        let newArr = arr.map(v=>v.saleNumber);
        val = newArr.reduce((a,b)=>(Number(a)+Number(b)).toFixed(0))
        return val
    }
    getStockTotal(arr){
        let val = 0;
        let newArr = arr.map(v=>v.stock);
        val = newArr.reduce((a,b)=>(Number(a)+Number(b)).toFixed(0))
        return val
    }
    editFun(){
        this.$router.push("/pad/product/editProduct?id="+this.id);
    }
    deleteFun(){
        if(this.form.isShelves&&!this.hasAuth('106')){
            Toast('暂无下架权限，请联系管理员')
            return;
        }
        if(!this.form.isShelves&&!this.hasAuth('105')){
            Toast('暂无上架权限，请联系管理员')
            return;
        }
        this.tipTitle = this.form.isShelves? "下架提醒":'上架提醒';
        this.tipText = this.form.isShelves? `下架后，该商品将无法被销售，确定下架吗？` : `确定上架该商品吗？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消";
        this.tipShow=true;
    }
    /**提示弹窗 */
    async tipConfirm(){
        let res = await TbGoods.PutUpdateTbGoodsIsShelves({
            id:this.id,
            isShelves:!this.form.isShelves
        })
        await this.init();
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }

    showPrint(){
        this.printShow = true;
    }
    closePrintFun(){
        this.printShow = false;
    }

    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/product/viewProduct.vue